import _ from "lodash";
import React from "react";
import classes from "./AddAttachment.scss";
import ScreenPanel from "../../ScreenPanel";
import { OneDriveIcon, GoogleDriveIcon, ImageIcon } from "SvgComponents";
import {
  SharePointOutlined,
  UploadOutlined,
  ImageSquareOutlined,
  GoogleDriveColored,
  OneDriveColored,
  PageSquareColored,
  SlidesColored,
  SheetsColored,
  GooglePhotosBrand,
} from "@toddle-edu/ds-icons";
import LinkModal from "UIComponents/LinkModal";
import DropzoneComponent from "UIComponents/DropzoneComponent";
import ButtonDropdown from "UIComponents/ButtonDropdown";
import MicrosoftPicker from "UIComponents/MicrosoftPicker";
import GooglePicker from "UIComponents/GooglePicker";
import SharepointPicker from "UIComponents/SharepointPicker";
import SharepointPickerV2 from "UIComponents/SharepointPicker/SharepointPickerV2";
import CreateDriveDocument from "UIComponents/CreateDriveDocument";
import GooglePhotosPicker from "UIComponents/GooglePhotosPicker";
import FullScreenLoader from "UIComponents/FullScreenLoader";
import I18nHOC from "UIComponents/I18nHOC";
import AttachmentItem from "./AttachmentItem";
import { connect } from "react-redux";
import { isImageCarousel, onEnterOrSpaceKeyDown } from "Utils";
import { colors, getCloudUrl } from "Constants";
import {
  setToastMsg,
  getUserInfo,
  enableGlobalHeader,
  disableGlobalHeader,
} from "Login/modules/LoginModule";
import { compose, graphql } from "lib/apolloClient";
import ACLStore from "lib/aclStore";
import {
  ENABLE_GOOGLE_DRIVE,
  ENABLE_ONE_DRIVE,
  ENABLE_CREATE_DRIVE_DOCUMENTS,
} from "Constants/permissionConstants";
import {
  GOOGLE_SERVICE_TYPE,
  MICROSOFT_SERVICE_TYPE,
  STUDENT_TEMPLATE_OPTION_NONE,
} from "Constants/stringConstants";
import { getOrganizationGlobalConstantsQuery } from "modules/CommonQuery";
import { getOrganizationGlobalConstantsFromCache } from "modules/CommonGraphqlHelpers";
import { hasIncludeGivenPathInCurrentRoute } from "Teacher/routes/Courses/routes/Course/routes/UnitPlans/routes/UnitPlanDetails/routes/EditUnitPlan/routes/IBPlanner/modules/IBPlannerModule";
import {
  isGlobalHeaderOnMultipleScreensEnabled,
  isPortfolioParityEnabled,
  isPortfolioParityEnabledAndIsJournalRoute,
  isIncreasedUploadLimitEnabled,
  SUBMISSION_MAX_AUDIO_RECORD_LIMIT,
} from "Post/utils";
import { getSelectedCurriculumId } from "modules/CommonSelectors";
import VoiceRecorderV2 from "Post/routes/CreatePost/components/Screens/VoiceRecorderV2";
import { Label } from "@toddle-edu/ds-web";
import {
  enableSharepointPickerForUser,
  enableSharepointPickerV2ForUser,
} from "UIComponents/SharepointPicker/modules/Utils";
import { enableGooglePhotosPicker } from "UIComponents/GooglePhotosPicker/modules/utils";
import classNames from "classnames";
import { flushSync } from "react-dom";

const buttonDropDownContainerStyle = {
  top: 144,
  marginTop: 12,
  marginBottom: 24,
  width: 260,
  left: 0,
};

const buttonDropDownContainerStyleV2 = {
  top: 144,
  marginTop: 12,
  marginBottom: 24,
  width: 240,
  left: 0,
  border: "none",
};
const styles = {
  modalBodyStyle: {
    marginTop: "0",
    padding: "8px 48px 48px 48px",
    flex: "0",
  },
  cancelButtonStyle: {
    flexBasis: "0%",
    marginRight: "0",
  },
  cancelButtonProps: {
    color: "transparent",
    type: "hollow",
    disableHover: true,
  },
  screenHeaderContainerStyle: {
    paddingLeft: "18px",
  },
};

const BLANK_OBJECT = {};
const ATTACHMENT_TYPES = {
  PHOTO: {
    type: "PHOTO",
    title: "common:photo",
    svgUrl: `${getCloudUrl()}/assets/webapp/journal_icons/photoIcon.svg`,
    color: colors.violet900,
    captureStep: "CAPTURE_IMAGE",
    mimeTypes: [
      "image/jpeg",
      "image/png",
      "image/jpg",
      "image/heic",
      "image/heif",
    ],
    multiple: true,
  },
  // PHOTO_COLLAGE: {
  //   type: "PHOTO_COLLAGE",
  //   title: "Photo Collage",
  //   svg: <CollageIconSvg fill={"white"} />,
  //   color: "#ff2d55"
  // },
  VOICE: {
    type: "VOICE",
    title: "common:voice",
    svgUrl: `${getCloudUrl()}/assets/webapp/journal_icons/voiceIcon.svg`,
    color: "#efdef8",
  },
  VIDEO: {
    type: "VIDEO",
    title: "common:video",
    captureStep: "CAPTURE_VIDEO",
    svgUrl: `${getCloudUrl()}/assets/webapp/journal_icons/videoIcon.svg`,
    color: "#ffdce5",
    mimeTypes: ["video/mp4", "video/avi", "video/wmv", "video/quicktime"],
  },
  FILE: {
    type: "FILE",
    title: "common:file",
    svgUrl: `${getCloudUrl()}/assets/webapp/journal_icons/fileIcon.svg`,
    color: "#bdf3e6",
    mimeTypes: undefined,
    multiple: isPortfolioParityEnabledAndIsJournalRoute(),
  },
  NOTE: {
    type: "NOTE",
    title: "common:note",
    svgUrl: `${getCloudUrl()}/assets/webapp/journal_icons/noteIcon.svg`,
    color: "#ffeabf",
  },
  LINK: {
    type: "LINK",
    title: "common:link",
    svgUrl: `${getCloudUrl()}/assets/webapp/journal_icons/linkIcon.svg`,
    color: "#c5f6ff",
  },
  WORKBOOK: {
    type: "WORKBOOK",
    title: "common:workbook",
    svgUrl: `${getCloudUrl()}/assets/webapp/journal_icons/drawingIcon.svg`,
    color: "#fee2d0",
  },
  ACTIVITY_FOOD: {
    type: "ACTIVITY_FOOD",
    title: "common:food",
    color: "#FFE0E6",
    perm: "EnableActivityTracker",
  },
  ACTIVITY_NAP: {
    type: "ACTIVITY_NAP",
    title: "common:nap",
    color: "#FFEDC1",
    perm: "EnableActivityTracker",
  },
  ACTIVITY_TOILET: {
    type: "ACTIVITY_TOILET",
    title: "common:toilet",
    color: "#CAF8FF",
    perm: "EnableActivityTracker",
  },
  TODDLE_DOC: {
    type: "TODDLE_DOC",
    title: "classRoom:toddle_doc_capitalized",
    color: "#E3E3FF",
    perm: "FeatureFlag:EnableToddleDocsInSubmissionTemplate",
  },
};

const GOOGLE_DOC_OPTIONS = [
  {
    serviceType: "GOOGLE",
    documentType: "DOCUMENT",
    icon: <PageSquareColored size="xx-small" />,
    label: "common:google_doc",
    dataTestId: "attachmentitemtypesubmenu:google_doc_option",
  },
  {
    serviceType: "GOOGLE",
    documentType: "SPREADSHEET",
    icon: <SheetsColored size="xx-small" />,
    label: "common:google_sheet",
    dataTestId: "attachmentitemtypesubmenu:google_sheets_option",
  },
  {
    serviceType: "GOOGLE",
    documentType: "PRESENTATION",
    icon: <SlidesColored size="xx-small" />,
    label: "common:google_slide",
    dataTestId: "attachmentitemtypesubmenu:google_slides_option",
  },
];
const MICROSOFT_DOC_OPTIONS = [
  {
    serviceType: "MICROSOFT",
    documentType: "DOCUMENT",
    icon: <PageSquareColored size="xx-small" />,
    label: "common:microsoft_word",
    dataTestId: "attachmentitemtypesubmenu:microsoft_word_option",
  },
  {
    serviceType: "MICROSOFT",
    documentType: "SPREADSHEET",
    icon: <SheetsColored size="xx-small" />,
    label: "common:microsoft_excel",
    dataTestId: "attachmentitemtypesubmenu:microsoft_excel_option",
  },
  {
    serviceType: "MICROSOFT",
    documentType: "PRESENTATION",
    icon: <SlidesColored size="xx-small" />,
    label: "common:microsoft_powerpoint",
    dataTestId: "attachmentitemtypesubmenu:microsoft_powerpoint_option",
  },
];

class AddAttachment extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showLinkModal: false,
      uploadCount: 0,
      showReorderModal: false,
      currentSelectedDropdown: {},
      showAudioModal: false,
      showDropdown: false,
      showCreateDriveDocument: false,
      serviceType: null,
      documentType: null,
    };
    this.photoDropDownRef = React.createRef();
    this.videoDropDownRef = React.createRef();
    this.uploadFileRef = React.createRef();
    this.currentAttachmentsRef = React.createRef();
    const {
      screenPanelProps: { updatePost },
    } = props;
  }

  componentDidMount = () => {
    const { disableGlobalHeader, screenPanelProps } = this.props;
    const {
      postDetails: { attachments = [] },
    } = screenPanelProps;
    this.currentAttachmentsRef.current = attachments;
    disableGlobalHeader();
  };
  componentWillUnmount = () => {
    const { enableGlobalHeader, screenPanelProps } = this.props;
    const { parentType } = screenPanelProps;
    isGlobalHeaderOnMultipleScreensEnabled() &&
      (parentType === "POST" ||
        parentType === "STUDENT_GOAL" ||
        parentType === "STUDENT_GOAL_TASK" ||
        _.isUndefined(parentType)) &&
      enableGlobalHeader();
  };

  componentDidUpdate = (prevProps, prevState) => {
    const {
      isGlobalHeaderVisible,
      disableGlobalHeader,
      screenPanelProps,
    } = this.props;
    const {
      postDetails: { attachments = [] },
    } = screenPanelProps;
    if (
      !_.isEqual(
        prevProps.screenPanelProps?.postDetails?.attachments,
        attachments
      )
    ) {
      this.currentAttachmentsRef.current = attachments;
    }

    if (
      isGlobalHeaderVisible &&
      prevProps?.isGlobalHeaderVisible !== isGlobalHeaderVisible &&
      isGlobalHeaderOnMultipleScreensEnabled()
    ) {
      disableGlobalHeader();
    }
  };

  onAttachmentSelected = async type => {
    const {
      screenPanelProps: {
        goToStep,
        updatePost,
        setWorkbookMode,
        setShowToddleDocModal,
      } = {},
    } = this.props;
    switch (type) {
      case "LINK":
        this.setState({ showLinkModal: true });
        break;
      case "WORKBOOK":
        isPortfolioParityEnabled() &&
          updatePost({ postType: type, attachments: [] });
        setWorkbookMode && setWorkbookMode("USE_TEMPLATE");
        break;
      case "VOICE":
        if (!isPortfolioParityEnabled()) {
          this.goToStep("VOICE_RECORDER");
          return;
        }
        this.setState({ showAudioModal: true });
        updatePost({ postType: type });
        break;
      case "NOTE":
        await updatePost({ attachments: [{ type: "NOTE", title: "" }] });
        this.goToStep("POST_DETAIL");
        break;
      case "ACTIVITY_FOOD":
        this.goToStep("MANAGE_FOOD_ACTIVITY");
        break;
      case "ACTIVITY_NAP":
        this.goToStep("MANAGE_NAP_ACTIVITY");
        break;
      case "ACTIVITY_TOILET":
        this.goToStep("MANAGE_TOILET_ACTIVITY");
        break;
      case "PHOTO":
        updatePost({ postType: type, attachments: [] });
        break;
      case "VIDEO":
        isPortfolioParityEnabled() &&
          updatePost({ postType: type, attachments: [] });
        break;
      case "TODDLE_DOC":
        isPortfolioParityEnabled() && setShowToddleDocModal(true);
        break;
      default:
        this.goToStep("POST_DETAIL");
    }
  };

  toggleLinkModal = () => {
    this.setState({ showLinkModal: !this.state.showLinkModal });
  };

  toggleAudioModal = () => {
    this.setState({ showAudioModal: !this.state.showAudioModal });
  };

  onLinkAdd = async ({ attachments }) => {
    const { screenPanelProps: { goToStep, updatePost } = {} } = this.props;

    await updatePost({ attachments });
    this.goToStep("POST_DETAIL");
  };

  updatePostAttachments = async attachment => {
    const {
      screenPanelProps: { updatePost },
    } = this.props;

    const currentAttachments = this.currentAttachmentsRef.current || [];
    const newAttachments = [...currentAttachments, attachment];

    // Update the ref first to prevent race conditions
    this.currentAttachmentsRef.current = newAttachments;

    flushSync(() => {
      updatePost({ attachments: newAttachments });
    });

    await updatePost({ attachments: newAttachments });
  };

  onContentUploaded = async postAttachments => {
    const {
      screenPanelProps: {
        updatePost,

        postDetails: { attachments = [] },
      },
    } = this.props;
    await updatePost({ attachments: postAttachments });
  };
  updateFilesCount = (count, isError, createMedia = false) => {
    const {
      screenPanelProps: {
        goToStep,
        postDetails: { attachments = [] },
        mediaCreationOptions,
        onMediaCreate,
      } = {},
    } = this.props;
    let newCount = this.state.uploadCount;
    newCount = newCount + count;
    const allowCarouselCreation = _.get(
      mediaCreationOptions,
      "allowCarouselCreation",
      true
    );

    flushSync(() => {
      this.setState({ uploadCount: newCount });
    });
    if (isError) {
      return;
    }
    if (newCount == 0) {
      if (createMedia) {
        onMediaCreate();
        return;
      }
      setTimeout(() => {
        if (
          isImageCarousel({ attachments }) &&
          allowCarouselCreation &&
          !isPortfolioParityEnabled()
        ) {
          this.goToStep("REORDER_IMAGES");
        } else {
          this.goToStep("POST_DETAIL");
        }
      }, 100);
    }
  };

  renderTabItem = ({ tab, index }) => {
    switch (tab.value) {
      default:
        return null;
    }
  };

  goToStep = (step, type = "") => {
    const {
      screenPanelProps: { goToStep },
    } = this.props;
    goToStep(step);
  };

  onFailedAllowedMimeType = () => {
    this.props.setToastMsg("toastMsgs:unsupported_file_format");
  };

  onDropDownItemClick = () => {
    // console.log("HERE");
    if (this.buttonDropDownRef) {
      // this.buttonDropDownRef.removeDocumentClickListener();
    }
  };

  onDropDownPhotoOrVideoItemClick = ({ item }) => {
    if (item.type === "PHOTO") {
      this.photoDropDownRef && this.photoDropDownRef.current?.click();
    } else {
      this.videoDropDownRef && this.videoDropDownRef.current?.click();
    }
  };

  onDropDownFileItemClick = () => {
    this.uploadFileRef && this.uploadFileRef.current?.click();
  };

  onSharePointClick = () => {
    if (
      this.sharepointPickerRef &&
      this.sharepointPickerRef.launchSharepointPicker
    ) {
      this.sharepointPickerRef.launchSharepointPicker();
    }
  };

  onGooglePhotosClicked = () => {
    if (this.photosPickerRef && this.photosPickerRef.launchGooglePhotosPicker) {
      this.photosPickerRef.launchGooglePhotosPicker();
    }
  };

  onHandleKeyDownGooglePhotos = e => {
    onEnterOrSpaceKeyDown(e, () => {
      this.onGooglePhotosClicked();
    });
  };

  onCreateDriveDocumentClick = ({ serviceType, documentType }) => {
    this.setState({
      showCreateDriveDocument: true,
      serviceType,
      documentType,
    });
  };

  closeDriveDocumentModal = () => {
    this.setState({
      showCreateDriveDocument: false,
      serviceType: null,
      documentType: null,
    });
  };

  updateButtonDropDownRef = ref => {
    this.buttonDropDownRef = ref;
  };

  setSharepointPickerRef = ref => {
    this.sharepointPickerRef = _.get(ref, "refs.wrappedInstance", {});
  };

  setGooglePhotosPickerRef = ref => {
    this.photosPickerRef = _.get(ref, "refs.wrappedInstance", {});
  };

  onAttachmentClose = () => {};

  renderUploadFromFileOptions = ({ item }) => {
    const {
      t,
      maxSize,
      isJournalRoute,
      showDesignV2,
      userType,
      screenPanelProps,
      isIncreasedUploadLimit,
      canCreateDriveFiles,
      isGoogleDriveEnabled,
      isMicrosoftDriveEnabled,
    } = this.props;
    const { allowMultipleFiles = false } = screenPanelProps;

    const hoverItemTextClass = showDesignV2
      ? canCreateDriveFiles
        ? classes.hoverItemTextV3
        : classes.hoverItemTextV2
      : classes.hoverItemText;

    const buttonIconAndTextClass = showDesignV2
      ? canCreateDriveFiles
        ? classes.buttonIconAndTextV3
        : classes.buttonIconAndTextV2
      : classes.buttonIconAndText;

    const dropDownItemContainerClass = classNames(
      classes.dropDownItemContainer,
      {
        [classes.dropDownItemContainerV2]: canCreateDriveFiles,
      }
    );

    const driveInnerClass = classNames(classes.googleDriveInnerDiv, {
      [classes.googleDriveInnerDivV2]: canCreateDriveFiles,
    });
    const iconSize = canCreateDriveFiles ? "xx-small" : "x-small";

    const onHandleKeyDropDown = e => {
      onEnterOrSpaceKeyDown(e, event => {
        this.onDropDownFileItemClick({ item });
      });
    };
    return (
      <div>
        <div
          className={dropDownItemContainerClass}
          style={{ borderBottom: showDesignV2 ? "none" : "" }}
          data-test-id={"attachmentitemtypesubmenu-upload_from_device"}
        >
          <DropzoneComponent
            multiple={
              item.multiple || isJournalRoute || allowMultipleFiles || false
            }
            parentId={null}
            parentType={"POST"}
            onClick={this.onDropDownItemClick}
            accessibileRef={this.uploadFileRef}
            renderComponent={
              <button
                className={buttonIconAndTextClass}
                id={"dropdown-item-upload_from_device"}
                tabIndex={0}
                onKeyDown={onHandleKeyDropDown}
              >
                {showDesignV2 ? (
                  <UploadOutlined variant="subtle" size={"xx-small"} />
                ) : (
                  <ImageIcon fill={colors.neutral400} height={16} width={16} />
                )}
                <div className={hoverItemTextClass}>
                  {canCreateDriveFiles
                    ? t("common:device")
                    : t("common:upload_device")}
                </div>
              </button>
            }
            onContentUploaded={
              isJournalRoute || allowMultipleFiles
                ? this.onContentUploaded
                : _.noop
            }
            sendFileOnContentUpload={isJournalRoute || allowMultipleFiles}
            onDropContent={this.updatePostAttachments}
            shouldUpload={false}
            accept={_.get(item, "mimeTypes", undefined)}
            onClose={this.onAttachmentClose}
            updateFilesCount={this.updateFilesCount}
            id={"dropdown-item-google_drive_picker"}
            tabIndex={0}
            isIncreasedUploadLimit={isIncreasedUploadLimit}
          />
        </div>

        {isGoogleDriveEnabled && (
          <div
            className={dropDownItemContainerClass}
            style={{ borderBottom: showDesignV2 ? "none" : "" }}
            onClick={this.onDropDownItemClick}
            data-test-id={"attachmentitemtypesubmenu-upload_from_google_drive"}
          >
            <GooglePicker
              parentId={null}
              parentType={"POST"}
              renderComponent={
                <button className={driveInnerClass}>
                  {showDesignV2 ? (
                    <GoogleDriveColored size={iconSize} />
                  ) : (
                    <GoogleDriveIcon fill={colors.neutral400} />
                  )}
                  <div className={hoverItemTextClass}>
                    {canCreateDriveFiles
                      ? t("common:google_drive")
                      : t("common:add_google_drive")}
                  </div>
                </button>
              }
              pickerType="GoogleDrive"
              classStyle={classes.iconSvgContainer}
              multiselect={isJournalRoute || allowMultipleFiles ? true : false}
              onContentLoaded={this.updatePostAttachments}
              onFailedAllowedMimeType={this.onFailedAllowedMimeType}
              thumbnailSize={"w248-h200"}
              shouldUpload={false}
              exportAsPdf={true}
              updateFilesCount={this.updateFilesCount}
              onClose={this.onAttachmentClose}
              maxSize={maxSize}
              isIncreasedUploadLimit={isIncreasedUploadLimit}
            />
          </div>
        )}
        {isMicrosoftDriveEnabled && !enableSharepointPickerV2ForUser(userType) && (
          <div
            className={dropDownItemContainerClass}
            style={{ borderBottom: showDesignV2 ? "none" : "" }}
            data-test-id={"attachmentitemtypesubmenu-upload_from_one_drive"}
            tabIndex={0}
            id={"dropdown-item-one_drive_picker"}
          >
            <MicrosoftPicker
              renderComponent={
                <button className={driveInnerClass}>
                  {showDesignV2 ? (
                    <OneDriveColored size={iconSize} />
                  ) : (
                    <OneDriveIcon fill={colors.neutral400} />
                  )}
                  <div className={hoverItemTextClass}>
                    {canCreateDriveFiles
                      ? t("common:one_drive")
                      : t("common:add_one_drive")}
                  </div>
                </button>
              }
              classStyle={classes.iconSvgContainer}
              thumbnailSize={"w248-h200"}
              parentId={null}
              parentType={"POST"}
              multiselect={isJournalRoute || allowMultipleFiles ? true : false}
              shouldUpload={false}
              onContentLoaded={this.updatePostAttachments}
              onFailedAllowedMimeType={this.onFailedAllowedMimeType}
              updateFilesCount={this.updateFilesCount}
              exportAsPdf={true}
              onClose={this.onAttachmentClose}
              maxSize={maxSize}
              isIncreasedUploadLimit={isIncreasedUploadLimit}
            />
          </div>
        )}
        {isMicrosoftDriveEnabled &&
          enableSharepointPickerForUser({ userType }) && (
            <div
              className={dropDownItemContainerClass}
              style={{ borderBottom: showDesignV2 ? "none" : "" }}
              onClick={this.onSharePointClick}
              data-test-id={"attachmentitemtypesubmenu:share_pointer_picker"}
              tabIndex={0}
              id={"dropdown-item-share_point_picker"}
            >
              {enableSharepointPickerV2ForUser(userType) ? (
                <SharepointPickerV2
                  renderComponent={
                    <div className={driveInnerClass}>
                      {showDesignV2 ? (
                        <OneDriveColored size={iconSize} />
                      ) : (
                        <OneDriveIcon fill={colors.neutral400} />
                      )}
                      <div className={hoverItemTextClass}>
                        {canCreateDriveFiles
                          ? t("common:onedrive_sharepoint")
                          : t("common:add_onedrive_sharepoint")}
                      </div>
                    </div>
                  }
                  ref={this.setSharepointPickerRef}
                  classStyle={classes.iconSvgContainer}
                  updateFilesCount={this.updateFilesCount}
                  onContentLoaded={this.updatePostAttachments}
                  onFailedAllowedMimeType={this.onFailedAllowedMimeType}
                  parentId={null}
                  parentType={"POST"}
                  multiselect={isJournalRoute || allowMultipleFiles}
                  shouldUpload={false}
                  exportAsPdf={true}
                  maxSize={maxSize}
                  isIncreasedUploadLimit={isIncreasedUploadLimit}
                />
              ) : (
                <SharepointPicker
                  renderComponent={
                    <div className={driveInnerClass}>
                      <SharePointOutlined size={iconSize} variant="subtle" />
                      <div className={classes.hoverItemText}>
                        {canCreateDriveFiles
                          ? t("common:sharepoint")
                          : t("common:add_sharepoint_drive")}
                      </div>
                    </div>
                  }
                  ref={this.setSharepointPickerRef}
                  classStyle={classes.iconSvgContainer}
                  updateFilesCount={this.updateFilesCount}
                  onContentLoaded={this.updatePostAttachments}
                  onFailedAllowedMimeType={this.onFailedAllowedMimeType}
                  parentId={null}
                  parentType={"POST"}
                  multiselect={isJournalRoute || allowMultipleFiles}
                  shouldUpload={false}
                  exportAsPdf={true}
                  maxSize={maxSize}
                  isIncreasedUploadLimit={isIncreasedUploadLimit}
                />
              )}
            </div>
          )}
        {isGoogleDriveEnabled && enableGooglePhotosPicker() && (
          <div
            className={dropDownItemContainerClass}
            style={{ borderBottom: showDesignV2 ? "none" : "" }}
            onClick={this.onGooglePhotosClicked}
            data-test-id={"attachmentitemtypesubmenu:google_photos_picker"}
            tabIndex={0}
            id={"dropdown-item-google_photos_picker"}
          >
            <GooglePhotosPicker
              renderComponent={
                <div className={driveInnerClass}>
                  <GooglePhotosBrand size={iconSize} />
                  <div className={hoverItemTextClass}>
                    {t("common:google_photos")}
                  </div>
                </div>
              }
              ref={this.setGooglePhotosPickerRef}
              classStyle={classes.iconSvgContainer}
              updateFilesCount={this.updateFilesCount}
              onContentLoaded={this.updatePostAttachments}
              parentId={null}
              parentType={"POST"}
              shouldUpload={false}
              maxSize={maxSize}
            />
          </div>
        )}
      </div>
    );
  };

  renderDropdownComponent = ({ item }) => {
    return (
      <div className={classes.dropDownContainer} id={"uploadFromFile"}>
        {this.renderUploadFromFileOptions({ item })}
      </div>
    );
  };

  /** Renders empty doc options for both google and microsoft */
  renderNewDocOptions = () => {
    const {
      t,
      showDesignV2,
      isGoogleDriveEnabled,
      isMicrosoftDriveEnabled,
      storageType,
    } = this.props;
    const hoverItemTextClass = showDesignV2
      ? classes.hoverItemTextV3
      : classes.hoverItemText;

    const optionStyle = { borderBottom: showDesignV2 ? "none" : "" };
    const onKeyDown = e => {
      if (e.key === "Enter" || e.key === " ") {
        this.onDropDownItemClick();
      }
    };
    const dropDownItemContainerClass = classNames(
      classes.dropDownItemContainer,
      classes.dropDownItemContainerV2
    );
    const driveInnerClass = classNames(
      classes.googleDriveInnerDiv,
      classes.googleDriveInnerDivV2
    );

    const NEW_DOC_OPTIONS = [];
    if (
      isGoogleDriveEnabled &&
      (_.isEmpty(storageType) || _.includes(storageType, GOOGLE_SERVICE_TYPE))
    ) {
      NEW_DOC_OPTIONS.push(...GOOGLE_DOC_OPTIONS);
    }
    if (
      isMicrosoftDriveEnabled &&
      (_.isEmpty(storageType) ||
        _.includes(storageType, MICROSOFT_SERVICE_TYPE))
    ) {
      NEW_DOC_OPTIONS.push(...MICROSOFT_DOC_OPTIONS);
    }

    return (
      <div>
        <div className={classes.labelContainer}>
          <Label label={t("common:create")} size="large" />
        </div>
        {NEW_DOC_OPTIONS.map(option => (
          <div
            key={option.dataTestId}
            className={dropDownItemContainerClass}
            style={optionStyle}
            onClick={() => {
              this.onCreateDriveDocumentClick({
                serviceType: option.serviceType,
                documentType: option.documentType,
              });
            }}
            data-test-id={option.dataTestId}
            role="button"
            tabIndex={0}
            onKeyDown={onKeyDown}
          >
            <div className={driveInnerClass}>
              {option.icon}
              <div className={hoverItemTextClass}>{t(option.label)}</div>
            </div>
          </div>
        ))}
      </div>
    );
  };

  /** Renders dropdown with itemGroup like UI */
  renderDropdownComponentV2 = ({ item }) => {
    const { t } = this.props;
    return (
      <div className={classes.dropDownContainer} id={"uploadFromFile"}>
        <div className={classes.dropDownItemGroupContainer}>
          <div className={classes.labelContainer}>
            <Label label={t("common:upload_from")} size="large" />
          </div>
          {this.renderUploadFromFileOptions({ item })}
        </div>
        <div>
          <div className={classes.separator}></div>
          <div className={classes.dropDownItemGroupContainer}>
            {this.renderNewDocOptions()}
          </div>
        </div>
      </div>
    );
  };

  renderPhotoVideoDropdownComponent = ({ item }) => {
    const {
      t,
      showDesignV2,
      isJournalRoute,
      screenPanelProps,
      maxSize,
    } = this.props;

    const driveInnerClass = classNames(
      classes.googleDriveInnerDiv,
      classes.googleDriveInnerDivV2
    );

    const { allowMultipleFiles = false } = screenPanelProps;
    const hoverItemTextClass = showDesignV2
      ? classes.hoverItemTextV2
      : classes.hoverItemText;
    const buttonIconAndTextClass = showDesignV2
      ? classes.buttonIconAndTextV2
      : classes.buttonIconAndText;
    const oneDriveInnerDivClass = showDesignV2
      ? classes.oneDriveInnerDivV2
      : classes.oneDriveInnerDiv;

    const onHandleKeyDownPhotoOrVideoDropdown = e => {
      onEnterOrSpaceKeyDown(e, event => {
        this.onDropDownPhotoOrVideoItemClick({ item });
      });
    };

    const onHandleKeyDownUploadDevice = e => {
      onEnterOrSpaceKeyDown(e, () => {
        this.goToStep(item.captureStep);
      });
    };
    return (
      <div className={classes.dropDownContainer}>
        <div
          className={classes.dropDownItemContainer}
          style={{ borderBottom: showDesignV2 ? "none" : "" }}
        >
          <DropzoneComponent
            multiple={item.multiple || isJournalRoute || allowMultipleFiles}
            parentId={null}
            parentType={"POST"}
            onClick={this.onDropDownItemClick}
            onContentUploaded={
              isJournalRoute || allowMultipleFiles
                ? this.onContentUploaded
                : _.noop
            }
            sendFileOnContentUpload={isJournalRoute || allowMultipleFiles}
            accessibileRef={
              item.type === "PHOTO"
                ? this.photoDropDownRef
                : this.videoDropDownRef
            }
            renderComponent={
              <button
                className={buttonIconAndTextClass}
                data-test-id={
                  "attachmentitemtypesubmenu-upload_photo_video_from_device:" +
                  item.type
                }
                id={"dropdown-item-upload_photo_from_device"}
                onKeyDown={onHandleKeyDownPhotoOrVideoDropdown}
              >
                {showDesignV2 ? (
                  <UploadOutlined variant="subtle" />
                ) : (
                  <ImageIcon fill={colors.neutral400} height={16} width={16} />
                )}
                <div className={hoverItemTextClass}>
                  {t("common:upload_device")}
                </div>
              </button>
            }
            onDropContent={this.updatePostAttachments}
            shouldUpload={false}
            accept={_.get(item, "mimeTypes", [])}
            onClose={this.onAttachmentClose}
            updateFilesCount={this.updateFilesCount}
          />
        </div>

        <button
          className={classes.dropDownItemContainer}
          style={enableGooglePhotosPicker() ? { borderBottom: "none" } : {}}
          onClick={() => this.goToStep(item.captureStep)}
          data-test-id={"attachmentitemtypesubmenu-capture_photo_video"}
          id={"dropdown-item-upload_video_from_device"}
          tabIndex={0}
          onKeyDown={onHandleKeyDownUploadDevice}
        >
          <div className={oneDriveInnerDivClass}>
            {showDesignV2 ? (
              <ImageSquareOutlined variant="subtle" />
            ) : (
              <OneDriveIcon fill={colors.neutral400} />
            )}
            <div className={hoverItemTextClass}>
              {item.type == "PHOTO"
                ? showDesignV2
                  ? t("journal:take_photo")
                  : t("common:capture_image")
                : showDesignV2
                ? t("journal:take_video")
                : t("common:capture_video")}
            </div>
          </div>
        </button>

        {item.type === "PHOTO" &&
        isJournalRoute &&
        enableGooglePhotosPicker() ? (
          <button
            className={classes.dropDownItemContainer}
            onClick={this.onGooglePhotosClicked}
            data-test-id={"attachmentitemtypesubmenu:google_photos_picker"}
            id={"dropdown-item-google_photos_picker"}
            tabIndex={0}
            onKeyDown={this.onHandleKeyDownGooglePhotos}
            aria-label={t("common:google_photos")}
          >
            <div className={oneDriveInnerDivClass}>
              <GooglePhotosPicker
                renderComponent={
                  <div className={driveInnerClass}>
                    <GooglePhotosBrand size={"x-small"} />
                    <div className={hoverItemTextClass}>
                      {t("common:google_photos")}
                    </div>
                  </div>
                }
                ref={this.setGooglePhotosPickerRef}
                classStyle={classes.iconSvgContainer}
                updateFilesCount={this.updateFilesCount}
                onContentLoaded={this.updatePostAttachments}
                parentId={null}
                parentType={"POST"}
                shouldUpload={false}
                maxSize={maxSize}
              />
            </div>
          </button>
        ) : null}
      </div>
    );
  };

  onUpdateShowDropDown = ({ type, value }) => {
    const { currentSelectedDropdown } = this.state;
    const updatedCurrentSelectedDropdown = _.cloneDeep(currentSelectedDropdown);
    updatedCurrentSelectedDropdown[type] = value;
    this.setState({ currentSelectedDropdown: updatedCurrentSelectedDropdown });
  };

  getAttachmentItem = ({ item, index }) => {
    const { currentSelectedDropdown } = this.state;
    const {
      screenPanelProps,
      t,
      showDesignV2,
      userType,
      audioRecordingLimit,
      canCreateDriveFiles,
      isMicrosoftDriveEnabled,
    } = this.props;
    const { updatePost, goToStep, parentType, screenTitle } = screenPanelProps;
    const isDropdownOpen = _.get(currentSelectedDropdown, item.type);
    const key = _.get(item, "type", index);
    const buttonDropDownContainerStyles = showDesignV2
      ? buttonDropDownContainerStyleV2
      : buttonDropDownContainerStyle;

    const onBlur = (callback, event) => {
      const { key } = event;
      event.preventDefault();
      if (
        (event.target?.id === "dropdown-item-upload_video_from_device" &&
          event.relatedTarget?.id !==
            "dropdown-item-upload_photo_from_device") ||
        event.target?.id ===
          _.last(document.getElementById("uploadFromFile")?.children)?.id ||
        key === "Tab" ||
        key === "ArrowDown"
      ) {
        callback();
        this.onUpdateShowDropDown({ type: item.type, value: false });
      }
    };

    const updateShowDropDownValue = type => value => {
      this.onUpdateShowDropDown({ type, value });
    };

    const fileContainerStyle =
      enableSharepointPickerV2ForUser(userType) && !canCreateDriveFiles
        ? { ...buttonDropDownContainerStyles, width: 300 }
        : !isMicrosoftDriveEnabled
        ? { ...buttonDropDownContainerStyles, width: 184 }
        : buttonDropDownContainerStyles;

    const fileDropdownComponent = canCreateDriveFiles
      ? this.renderDropdownComponentV2({ item })
      : this.renderDropdownComponent({ item });

    switch (item.type) {
      case "PHOTO":
        return (
          <ButtonDropdown
            key={key}
            containerStyle={buttonDropDownContainerStyles}
            buttonComponent={
              <AttachmentItem
                item={item}
                isDropdownOpen={isDropdownOpen}
                onAttachmentSelected={this.onAttachmentSelected}
              />
            }
            dropdownComponent={this.renderPhotoVideoDropdownComponent({ item })}
            ref={this.updateButtonDropDownRef}
            onUpdateShowDropDown={updateShowDropDownValue(item.type)}
            showFocus={true}
            onBlur={onBlur}
          />
        );
      case "VIDEO":
        return ACLStore.can("Common:WebcamRecording") ? (
          <ButtonDropdown
            key={key}
            containerStyle={buttonDropDownContainerStyles}
            buttonComponent={
              <AttachmentItem
                item={item}
                isDropdownOpen={isDropdownOpen}
                onAttachmentSelected={this.onAttachmentSelected}
                closeDropDown={this.closeDropDown}
              />
            }
            dropdownComponent={this.renderPhotoVideoDropdownComponent({ item })}
            ref={this.updateButtonDropDownRef}
            onUpdateShowDropDown={value =>
              this.onUpdateShowDropDown({ type: item.type, value })
            }
            showFocus={true}
            onBlur={onBlur}
          />
        ) : (
          <DropzoneComponent
            key={key}
            multiple={_.get(item, "multiple", false)}
            parentId={null}
            parentType={"POST"}
            renderComponent={<AttachmentItem item={item} />}
            onDropContent={this.updatePostAttachments}
            accept={_.get(item, "mimeTypes", [])}
            shouldUpload={false}
            onFailedAllowedMimeType={this.onFailedAllowedMimeType}
            updateFilesCount={this.updateFilesCount}
          />
        );

      case "FILE":
        return (
          <ButtonDropdown
            key={key}
            containerStyle={fileContainerStyle}
            buttonComponent={
              <AttachmentItem item={item} isDropdownOpen={isDropdownOpen} />
            }
            dropdownComponent={fileDropdownComponent}
            ref={this.updateButtonDropDownRef}
            onUpdateShowDropDown={value =>
              this.onUpdateShowDropDown({ type: item.type, value })
            }
            showFocus={true}
            onBlur={onBlur}
          />
        );

      case "WORKBOOK":
      case "TODDLE_DOC":
        return (
          <AttachmentItem
            item={item}
            key={key}
            onAttachmentSelected={this.onAttachmentSelected}
          />
        );
      case "VOICE":
        return isPortfolioParityEnabled() ? (
          <VoiceRecorderV2
            title={t("common:record_audio")}
            updateInputField={() => {}}
            buttonComponent={
              <AttachmentItem
                item={item}
                key={key}
                onAttachmentSelected={this.onAttachmentSelected}
              />
            }
            updatePost={updatePost}
            postDetails={{ attachments: [] }}
            goToStep={goToStep}
            reloadText={t("journal:restart")}
            submitText={
              _.isEqual(parentType, "STUDENT_ASSIGNMENT_SUBMISSION")
                ? screenTitle
                : t("journal:add_to_post")
            }
            tooltip={t("common:record_audio")}
            customCallback={() => {
              goToStep("POST_DETAIL");
            }}
            audioRecordingLimit={audioRecordingLimit}
          />
        ) : (
          <AttachmentItem
            item={item}
            key={key}
            onAttachmentSelected={this.onAttachmentSelected}
          />
        );
      default:
        return (
          <AttachmentItem
            item={item}
            key={key}
            onAttachmentSelected={this.onAttachmentSelected}
          />
        );
    }
  };

  render() {
    const {
      screenPanelProps,
      t,
      maxSize,
      isJournalRoute,
      showDesignV2,
    } = this.props;
    const {
      showLinkModal,
      uploadCount,
      showCreateDriveDocument,
      serviceType,
      documentType,
    } = this.state;
    const addMediaOptions = _.get(
      screenPanelProps,
      "mediaCreationOptions.addMediaOptions",
      []
    );
    const { parentId: submissionId, parentType } = screenPanelProps;
    const isStudentAssignmentSubmission =
      _.isEqual(parentType, "STUDENT_ASSIGNMENT_SUBMISSION") &&
      !_.isEmpty(submissionId);

    const extraCreateDriveDocumentProps = isStudentAssignmentSubmission
      ? { submissionId, type: "SUBMISSION_DOCUMENT" }
      : {};

    return (
      <ScreenPanel
        {...screenPanelProps}
        screenHeaderContainerStyle={
          isPortfolioParityEnabled() && isJournalRoute
            ? styles.screenHeaderContainerStyle
            : BLANK_OBJECT
        }
        showNewHeaderDesign={isPortfolioParityEnabled()}
      >
        <div className={classes.container}>
          <div className={classes.iconContainer}>
            {_.map(addMediaOptions, (item, index) => {
              const addMediaOption = ATTACHMENT_TYPES[item];
              if (
                !_.isNil(_.get(addMediaOption, "perm")) &&
                !ACLStore.can(_.get(addMediaOption, "perm"))
              )
                return;
              if (
                _.isEqual(item, "WORKBOOK") &&
                !ACLStore.can("FeatureFlag:Workbook") //permission to add workbook in journal
              )
                return;
              return this.getAttachmentItem({
                item: { ...addMediaOption, title: t(addMediaOption.title) },
                index,
              });
            })}
          </div>
        </div>

        {!!showLinkModal && (
          <LinkModal
            onLinkAdd={this.onLinkAdd}
            onClose={this.toggleLinkModal}
          />
        )}

        {showCreateDriveDocument && (
          <CreateDriveDocument
            t={t}
            closeDriveDocument={this.closeDriveDocumentModal}
            onSingleContentUploaded={this.updatePostAttachments}
            updateFilesCount={this.updateFilesCount}
            parentType={"POST"}
            serviceType={serviceType}
            documentType={documentType}
            {...extraCreateDriveDocumentProps}
          />
        )}

        {uploadCount > 0 && <FullScreenLoader />}
      </ScreenPanel>
    );
  }
}

const mapActionCreators = {
  setToastMsg,
  enableGlobalHeader,
  disableGlobalHeader,
};

const mapStateToProps = (state, ownProps) => {
  const isJournalRoute =
    hasIncludeGivenPathInCurrentRoute({
      path: "/journal",
    }) && isPortfolioParityEnabled();
  const userInfo = getUserInfo();
  const userType = _.get(userInfo, "user_type", "");
  const orgId = _.get(userInfo, "org_id", "");
  const isGlobalHeaderVisible = _.get(
    state,
    "login.globalHeader.isVisible",
    false
  );
  const parentType = _.get(ownProps, "screenPanelProps.parentType");

  const isSubmissionType = _.isEqual(
    parentType,
    "STUDENT_ASSIGNMENT_SUBMISSION"
  );
  const curriculumProgramId = getSelectedCurriculumId(state);
  const isIncreasedUploadLimit =
    isIncreasedUploadLimitEnabled(curriculumProgramId) && isSubmissionType;
  const audioRecordingLimit = _.get(
    ownProps,
    "screenPanelProps.audioRecordingLimit"
  );

  const isGoogleDriveEnabled = ACLStore.can(ENABLE_GOOGLE_DRIVE);
  const isMicrosoftDriveEnabled = ACLStore.can(ENABLE_ONE_DRIVE);
  const canCreateDriveFiles =
    (isGoogleDriveEnabled || isMicrosoftDriveEnabled) &&
    ACLStore.can(ENABLE_CREATE_DRIVE_DOCUMENTS);
  return {
    isJournalRoute,
    userType,
    orgId,
    parentType,
    isGlobalHeaderVisible,
    isIncreasedUploadLimit,
    audioRecordingLimit: isIncreasedUploadLimit
      ? SUBMISSION_MAX_AUDIO_RECORD_LIMIT
      : audioRecordingLimit,
    isGoogleDriveEnabled,
    isMicrosoftDriveEnabled,
    canCreateDriveFiles,
  };
};

export default compose(
  connect(mapStateToProps, mapActionCreators),
  I18nHOC({ resource: ["journal", "common"] }),
  graphql(getOrganizationGlobalConstantsQuery, {
    name: "getOrganizationGlobalConstants",
    options: ({ orgId }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        organizationId: orgId,
        filter: {
          names: ["THIRD_PARTY_SERVICE_TYPE_PREFERENCE"],
        },
      },
    }),
    skip: ({ canCreateDriveFiles }) => {
      return !canCreateDriveFiles;
    },
    props({
      getOrganizationGlobalConstants,
      ownProps: { canCreateDriveFiles },
    }) {
      const data = getOrganizationGlobalConstantsFromCache(
        getOrganizationGlobalConstants.variables
      );
      const organizationConstants = _.get(data, "node.globalConstants", []);
      const storageTypeString = _.get(
        _.find(organizationConstants, {
          name: "THIRD_PARTY_SERVICE_TYPE_PREFERENCE",
        }),
        "value",
        JSON.stringify([GOOGLE_SERVICE_TYPE])
      );
      let storageType = JSON.parse(storageTypeString);
      storageType = _.isEmpty(data)
        ? [STUDENT_TEMPLATE_OPTION_NONE]
        : storageType;
      canCreateDriveFiles =
        !_.includes(storageType, STUDENT_TEMPLATE_OPTION_NONE) &&
        canCreateDriveFiles;
      return {
        storageType,
        canCreateDriveFiles,
      };
    },
  })
)(AddAttachment);
